import { parseCliJson } from '@cli-utils/process.js'

/** The Vercel CLI prints human banners around its `--format json` output. */
export function parseVercelJson<T = unknown>(stdout: string): T | undefined {
  return parseCliJson<T>(stdout)
}
